"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearedOnboardingContext = exports.publishedOnboardingContext = void 0;
const initial_1 = __importDefault(require("@app/store/initial"));
const toolkit_1 = require("@reduxjs/toolkit");
/**
 * Read-only snapshots of what is on the manager's screen, published by the page that draws
 * it and read by the manager assistant when it sends a message (it ends up in the chat's
 * `metadata.viewContext` — see
 * `app/component/core/manager-assistant/manager-assistant-chat.tsx`).
 *
 * It exists because not everything the agent would like to see is in the store: the
 * onboarding checklist derives its steps inside a component hook, and the modal + table
 * context named in `../../../assistant-n8n/PLAN.md` is React-resident too. A page publishing
 * a small snapshot here is the alternative to teaching the chat to read React state.
 *
 * Everything in here describes what the manager is looking at RIGHT NOW: each publisher clears
 * its own entry as soon as it has nothing to say, and the slice is deliberately absent from
 * the `app/store/persist.js` whitelist — a snapshot restored from localStorage would describe
 * a screen nobody is looking at.
 */
const uiContextSlice = (0, toolkit_1.createSlice)({
    name: 'uiContext',
    initialState: initial_1.default.uiContext,
    reducers: {
        publishedOnboardingContext: (state, action) => {
            state.onboarding = action.payload;
        },
        clearedOnboardingContext: (state) => {
            state.onboarding = undefined;
        },
    },
});
_a = uiContextSlice.actions, exports.publishedOnboardingContext = _a.publishedOnboardingContext, exports.clearedOnboardingContext = _a.clearedOnboardingContext;
exports.default = uiContextSlice.reducer;
